import { reactive } from 'vue';
import { createApiClient, signInFromFrame } from '@flagships/rails-frontend';

export const API_BASE = '/api';
export interface Boot {
  portal: { domain: string; isTest: boolean; card?: string };
  user: { name: string; role: string; isPortalAdmin: boolean };
  setup: { step: string; connectedAt: string | null; yandex: 'ok' | 'revoked' | null; transfer?: 'ok' | 'broken' };
  landing: string;
}
export const session = reactive({
  token: null as string | null,
  user: null as null | { name: string; role: string; isPortalAdmin: boolean },
  landing: 'deals',
  boot: null as Boot | null,
});

// Снимки экранов вне фрейма: tools/ui-shot.mjs кладёт токен разработки до загрузки страницы.
// Для панели браузера разработчика токен можно положить и в localStorage (`fs:devToken`); в сборке для прода этого кода нет.
const devToken = (window as unknown as { __fsDevToken?: string }).__fsDevToken ?? (import.meta.env.DEV ? localStorage.getItem('fs:devToken') ?? undefined : undefined);
if (import.meta.env.DEV && devToken) { session.token = devToken; session.user = { name: 'Разработка', role: 'marketer', isPortalAdmin: true }; }

export async function signIn() {
  const r = await signInFromFrame(API_BASE);
  session.token = r.token; session.user = r.user; session.landing = r.landing;
  return r;
}
export const api = createApiClient({ baseURL: API_BASE, getToken: () => session.token, reauth: async () => (await signIn()).token });

export async function loadBoot(): Promise<Boot> {
  const b = (await api.get<Boot>('/bootstrap')).data;
  session.boot = b; session.user = b.user; session.landing = b.landing;
  return b;
}

export const canSetup = () => ['admin', 'marketer'].includes(session.user?.role ?? '');
